export default async function AccessAPI(url,options = {}) {
  const response = await fetch('https://blogtracer.herokuapp.com' + url, options);
  const data = await response.json();
  return data;
}
